import { InvoiceDTO, Permission, Res } from 'core/api';
import { Command } from 'pos/common';
import { Result, SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { PartialRefundScreen } from './PartialRefundScreen';
import * as PartialRefund from './PartialRefund';
import * as InvoicePreconditions from '../invoices/Preconditions';
import { Message, Modal } from 'core/ui-next/modal';
import { InvoiceFacade } from 'pos/facades';

declare global {
	interface CommandType {
		createInvoicePartialRefund: (invoice: InvoiceDTO) => Promise<Result>
	}
}

Command.register('createInvoicePartialRefund', Preconditions.ensure(Permission.Ticket_PartialRefund), async (invoice: InvoiceDTO): Promise<Result> => {

	const canBeRefunded = await InvoicePreconditions.ensureCanRefund(invoice);
	if (!canBeRefunded)
		return Result.error();

	const originalPayments = await InvoiceFacade.getOriginalPaymentsToRefund(invoice.Id);
	if (originalPayments.some(x => x.CardTransaction.TransactionId) && !SessionProvider.hasPermission(Permission.CardProcessor_AllowUnreferencedRefunds)) {
		await Message.show(Res.Msg.MSG_CANNOT_REFUND_INVOICE_WITH_CARD_PAYMENTS_WITHOUT_UNREFERENCED_REFUNDS_PERMISSION());
		return Result.error();
	}

	const initResult = await PartialRefund.init(invoice);
	if (!initResult.ok) {
		await Message.show(initResult.error.message);
		return Result.error();
	}

	return await Modal.show(PartialRefundScreen, { status: initResult.value });
});
